export { default as IconCheckmark } from './Checkmark';
export { default as IconCogs } from './Cogs';
export { default as IconDatabase } from './Database';
export { default as IconDisplay } from './Display';
export { default as IconDownload } from './Download';
export { default as IconEmbed } from './Embed';
export { default as IconGitHub } from './GitHub';
export { default as IconLinkedIn } from './LinkedIn';
export { default as IconLocation } from './Location';
export { default as IconMail } from './Mail';
export { default as IconMenu } from './Menu';
export { default as IconMeter } from './Meter';
export { default as IconMobile } from './Mobile';
export { default as IconPackage } from './Package';
export { default as IconPhone } from './Phone';
export { default as IconSphere } from './Sphere';
export { default as IconStack } from './Stack';
export { default as IconStar } from './Star';
export { default as IconHalfStar } from './StarHalf';
export { default as IconEmptyStar } from './StarEmpty';
export { default as IconTerminal } from './Terminal';
export { default as IconTwitter } from './Twitter';



// WEBPACK FOOTER //
// ./src/components/Icon/svg/index.js